<template>
	<div id='' class='gPageBorder' v-loading='loading'>

		<el-dialog class='' :title="$t('app_tip')" :visible.sync="cerDialogVisible" size="tiny"
			:before-close="handleClose">
			<span>{{cerTipMsg}}</span>
			<span slot="footer" style='text-align:center'>
				<el-button @click="cerDialogVisible = false">{{$t('app_cancel')}}</el-button>
				<!-- <el-button type="primary" @click="pushCreateCer">{{$t()}}</el-button> -->
				<el-button type="primary" @click="pushUploadCer">{{$t('app_uploadCer')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog class='' :title="$t('app_tip')" :visible.sync="cerTipDialogVisible" size="tiny"
			:before-close="handleClose">
			<span>{{cerTipMsg}}</span>
			<span slot="footer" style='text-align:center'>
				<el-button type='primary' @click="cerTipDialogVisible = false">{{$t('app_sure')}}</el-button>
			</span>
		</el-dialog>

		<el-dialog class='gDia' :title="$t('app_addPush')" v-model="dialogVisible" size='middle'>
			<div v-loading='dvLoading'>
				<div style='width:100%;background:none;text-align:left;' class='gDiaTable'>

					<span>

						<el-select @change='selectDvChange' style='width:16%;margin-right:10px;' v-model="channelId"
							clearable :placeholder="$t('app_distributor')">
							<el-option v-for="item in channels" :key="item.mechanismid" :label="item.mechanismname"
								:value="item.mechanismid">
							</el-option>
						</el-select>
					</span>

					<span>

						<el-select @change='selectDvChange' style='width:16%;margin-right:10px;' v-model="status"
							clearable :placeholder="$t('app_status')">
							<el-option v-for="item in stModel" :key="item.vl" :label="item.label" :value="item.vl">
							</el-option>
						</el-select>
					</span>


					<el-input :placeholder="$t('app_searchTerminal')" icon="search" @keyup.enter.native='srchDevice'
						style='width:40%;margin-bottom:10px;' v-model="srchValue">
					</el-input>
				</div>




				<el-table :data="dvTableData" border tooltip-effect="dark" style="width: 100%">
					<el-table-column align='center' prop="terminalNo" :label="$t('app_terNo')" width="150">
					</el-table-column>
					<el-table-column align='center' prop="terminalName" :label="$t('app_terName')" width="130">
					</el-table-column>
					<el-table-column prop="terminal_status" align='center' :label="$t('app_status')" width="90">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.terminalStatus == 1 " type="success"
								size="mini">{{$t('app_online')}}</el-tag>
							<el-tag v-if="scope.row.terminalStatus == 2 " type="danger"
								size="mini">{{$t('app_offline')}}</el-tag>
							<el-tag v-if="scope.row.terminalStatus == 0 " type="gray"
								size="mini">{{$t('app_new')}}</el-tag>
						</template>
					</el-table-column>
					<el-table-column align='center' prop="mechName" :label="$t('app_distributor')" width=''>
					</el-table-column>
					<el-table-column prop="operate" :label="$t('app_operate')" align='center' width=''>
						<template slot-scope='scope'>
							<!-- <el-button  @click='bindOperate(scope.row)' type=text>{{$t('app_push')}}</el-button> -->
							<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
								<el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-trash-o"
										style="color:#FF4949"></i></el-button>
							</el-tooltip>
						</template>
					</el-table-column>
				</el-table>

				<div class="block" style=''>

					<el-pagination @current-change="pageDvSelect" @size-change="pageDvSized" :current-page="dvIndex"
						:page-sizes='$gRows' :page-size="row" layout="total, sizes, prev, pager, next, jumper"
						:total="dvTotal">
					</el-pagination>
					<!-- <el-pagination
          small
          layout="prev, pager, next"
          :total="dvTotal">
        </el-pagination> -->

				</div>
			</div>
		</el-dialog>

		<div id=''>
			<div style=''>

				<el-row>
					<el-col :span="8" class=''>
						<el-button class='gSgLeftBtn' type='primary'
							@click='jumpToUpload'>{{$t('app_uploadApp')}}</el-button>

						<!-- <el-button :disabled="tempSelect.length<=0" class='gSgLeftBtn' type='' @click='batchPush'>{{$t('app_mulPush')}} ({{sNum}})</el-button> -->
					</el-col>



					<el-col :span="4">
						<div class='gCtrl'>
							<el-select v-model="appvst" clearable :placeholder="$t('app_vStatus')"
								@change='selectChange'>
								<el-option v-for="item in appvStatus" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>

						</div>
					</el-col>

					<el-col :span="4">
						<div class='gCtrl'>
							<MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector>
						</div>
					</el-col>

					<el-col :span="4">
						<div class='gCtrl'>
							<el-input v-model='pkg' @keyup.enter.native='query' icon="search" :on-icon-click="query"
								:placeholder="$t('app_ippkgname')"></el-input>
							<!-- <el-cascader
                expand-trigger="hover"
                clearable
                :placeholder="$t('app_type')"
                :options="appTypes"
                @change='selectChange'
                :show-all-levels="false"
                v-model="appType"
              ></el-cascader> -->
						</div>
					</el-col>


					<el-col :span="4">
						<div class='gSideCtrl'>
							<el-input :placeholder="$t('app_appName')" v-model='queryKey' @keyup.enter.native='query'
								icon="search" :on-icon-click="query"></el-input>
						</div>
					</el-col>

				</el-row>


			</div>
		</div>


		<div id=''>
			<el-table @row-click='cellClick' :data="tableData" border @sort-change='sortChange' ref="multipleTable"
				@selection-change="handleSelectionChange" class='tbPoint gTopMg' style="width: 100%;border:none;">
				<!-- <el-table-column
          header-align='center'
          align='center'
          prop=""
          :label="$t('app_No')"
          width="70">
          <template slot-scope='scope'>
            <label>{{scope.$index + 1}}</label>
          </template>
        </el-table-column> -->
				<!-- <el-table-column
          align=center
  	      type="selection"
  	      width="55">
  	    </el-table-column> -->
				<el-table-column header-align='center' align='center' prop="appName" sortable="custom"
					:label="$t('app_appName')" width="">
				</el-table-column>
				<el-table-column header-align='center' align='center' prop="appCategoryName" width=''
					:label="$t('app_type')">
				</el-table-column>

				<!-- <el-table-column
          header-align='center'
          align='center'
          prop="appInstallType"
          width=''
          :label="$t('app_insType')">
          <template slot-scope='scope'>
            <el-label>{{setInstallType(scope.row.appInstallType)}}</el-label>
          </template>
        </el-table-column> -->

				<el-table-column header-align='center' align='center' prop="distributorName" width=''
					:label="$t('app_distributor')">
				</el-table-column>
				<el-table-column header-align='center' align='center' width='115' :label="$t('app_vStatus')">
					<template slot-scope='scope'>
						<el-label
							:style='getStatus(scope.row.appStatus).style'>{{getStatus(scope.row.appStatus).vl}}</el-label>
					</template>
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="appVersion" width=''
					:label="$t('app_newgVer')">
				</el-table-column>

				<el-table-column header-align='center' align='center' prop="createTime" width='175' sortable="custom"
					:label="$t('app_ulTime')">
				</el-table-column>

				<!-- :formatter="dateFormat" -->

				<el-table-column header-align='center' align='right' prop="operate" width='106'
					:label="$t('app_operate')">
					<template slot-scope='scope'>

						<span style='background:none;'>

							<!-- <el-button v-show="scope.row.appStatus === '2'" type=text @click='pushApp(scope.row)'>{{$t('app_push')}}</el-button> -->
							<!-- <el-tooltip class="item" effect="dark" :content="$t('lin_btn.send')" placement="top">
              <el-button v-show="scope.row.appStatus == 2" type='text' @click='pushApp(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip> -->

							<el-tooltip class="item" effect="dark" :content="$t('app_edit')" placement="top">
								<el-button v-show='scope.row.appStatus == 0 || scope.row.appStatus == 3' type='text'
									@click='editApp(scope.row)'><i class="fa fa-pencil" style=""></i></el-button>
							</el-tooltip>



							<!-- <el-button v-show="scope.row.appStatus !== '1' && scope.row.appStatus !== '2' && scope.row.isoperation === 0" @click='submitApp(scope.row)' type='text'>{{$t('app_smVerify')}}</el-button> -->
							<el-tooltip class="item" effect="dark" :content="$t('app_smVerify')" placement="top">
								<el-button
									v-show="scope.row.appStatus !== '1' && scope.row.appStatus !== '2' && scope.row.isoperation === 0"
									type='text' @click='submitApp(scope.row)'><i class="fa fa-arrow-up"
										style=""></i></el-button>
							</el-tooltip>

							<!-- <el-button v-show='scope.row.isoperation === 0' type=text @click='deleteApp(scope.row)'>{{$t('app_del')}}</el-button> -->
							<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
								<el-button v-show='scope.row.isoperation === 0' type='text'
									@click='deleteApp(scope.row)'><i class="fa fa-trash"
										style="color:#FF4949"></i></el-button>
							</el-tooltip>

						</span>
					</template>
				</el-table-column>
			</el-table>

			<div class="gPgDiv" style=''>
				<el-pagination class='gPg' @current-change="pageSelect" @size-change="pageSized" :current-page="index"
					:page-sizes='$gRows' :page-size="row" layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<style>
	// html,body{width:100%;height:100%;}

	.tbPoint td {
		cursor: pointer;
	}

	.cmMarginFrame {
		width: calc(100% - 20px);
		height: 100%;
		background: none;
		margin-left: 10px;
	}

	#appDepot {
		min-width: 840px;
	}

	#adData {}
</style>

<script>
	import mm from "moment";
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	//import autoTerno from '../global/TernoAutoCtrl'
	export default {
		components: {
			MechanismSelector
		},
		data() {
			return {
				mechanismData: '',
				orderName: '',
				orderType: '',
				appvst: '',
				pkg: '',
				cerDialogVisible: false,
				cerTipDialogVisible: false,
				dvLoading: 0,
				appId: "",
				stModel: [{
						label: this.$t("app_online"),
						vl: "1"
					},
					{
						label: this.$t("app_offline"),
						vl: "2"
					},
					{
						label: this.$t("app_new"),
						vl: "0"
					}
				],
				channels: [],
				sNum: 0,
				cleanMode: false,
				multipleSelection: [],
				tempSelect: [],
				srchValue: "",
				channelId: "",
				cerTipMsg: "",
				status: "",
				dvIndex: 1,
				dialogVisible: 0,
				mechanismId: window.localStorage["mechanismId"],
				mechId: '',
				tableData: [],
				dvTableData: [],
				appTypes: [],
				appTypeValue: "",
				// selectAll: {},
				appvStatus: [{
						label: this.$t("app_prePushVerify"),
						value: "0"
					},
					{
						label: this.$t("app_preVerify"),
						value: "1"
					},
					{
						label: this.$t("app_verifyPass"),
						value: "2"
					},
					{
						label: this.$t("app_verifyNotPass"),
						value: "3"
					}
				],
				// appStatus: [
				//   { label: this.$t("app_prePushVerify"), value: "0" },
				//   { label: this.$t("app_preVerify"), value: "1" },
				//   { label: this.$t("app_verifyPass"), value: "2" },
				//   { label: this.$t("app_verifyNotPass"), value: "3" }
				// ],
				appStatusValue: "",
				total: 0,
				dvTotal: 0,
				loading: 0,
				appType: "",
				queryKey: ""
			};
		},
		computed: {
			index() {
				return this.$getWPage("appPage");
			}
		},
		methods: {
			sortChange(vl) {
				switch (vl.prop) {
					case 'appName':
						this.orderName = '1'
						break
					case 'createTime':
						this.orderName = '2'
						break
				}
				this.orderType = vl.order == 'descending' ? 'desc' : 'asc'
				this.getAppList()
			},
			editApp(row) {
				this.$setWObj("editAppConfig", {
					data: row,
					type: 1
				});
				this.$router.push({
					path: '/applist/edit'
				});
			},
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {

				this.sNum = val.length
				this.tempSelect = val

				if (val.length > 5) {
					this.$message(this.$t('app_pushnumcantfive'))
					return
				}

				if (!this.selectedAppLegal()) {
					this.$message(this.$t('app_selectedappshoupass'))
					return
				}
			},
			selectedAppLegal() {
				var ishit = false
				this.tempSelect.forEach((vl) => {
					if (vl.appStatus != '2') {
						ishit = true
						return true
					}
				})
				return !ishit
			},
			batchPush() {

				if (this.tempSelect.length > 5) {
					this.$message(this.$t('app_pushnumcantfive'))
				} else if (!this.selectedAppLegal()) {
					this.$message(this.$t('app_selectedappshoupass'))
				} else {
					// console.log(this.tempSelect)
					this.$setWObj("pushList", {
						data: this.tempSelect,
						type: "1"
					});
					this.$router.push({
						path: "/appList/pushapp"
					});
				}

			},
			pushCreateCer() {
				this.$router.push({
					path: "/certificate/new"
				});
			},
			pushUploadCer() {
				this.$router.push({
					path: "/certificate/upload"
				});
			},
			bindOperate(row) {
				//console.log(row)

				this.dvLoading = 1;
				if (this.$appUrlTag === 0) {
					this.$bindApp(
						"0",
						row.terminalNo,
						this.appId,
						res => {
							if (res.status === 200) {
								this.$message.success(this.$t("app_tipViewTask"));
							} else {
								this.$message.error(res.message);
							}
							this.dvLoading = 0;
						},
						() => {
							// error
							this.dvLoading = 0;
						}
					);
				} else {
					// console.log(localStorage.mechanismId, tNo)
					this.$bindApp1(
						this.mechanismId,
						row.terminalNo,
						this.appId,
						res => {
							if (res.status === 200) {
								this.$message.success(this.$t("app_tipViewTask"));
							} else {
								this.$message.error(res.message);
							}
							this.dvLoading = 0;
						},
						() => {
							// error
							this.dvLoading = 0;
						}
					);
				}
			},
			getChannels() {
				this.$getChannelList(
					10000,
					1,
					'',
					'',
					'',
					res => {
						if (res.status === 200) {
							this.channels = res.data;
						} else {
							this.$message.error(res.message);
						}
					},
					() => {
						// error
						this.$message.error(this.$t("app_rqsError"));
					}
				);
			},
			getStatus(value) {
				switch (value) {
					case "0":
						return {
							vl: this.$t("app_prePushVerify"), style: "color:#8492A6;"
						};
					case "1":
						return {
							vl: this.$t("app_preVerify"), style: "color:#F7BA2A;"
						};
					case "2":
						return {
							vl: this.$t("app_verifyPass"), style: "color:#13CE66;"
						};
					case "3":
						return {
							vl: this.$t("app_verifyNotPass"), style: "color:#FF4949;"
						};
				}
			},
			srchDevice() {
				this.getDevices();
			},
			selectDvChange(vl) {
				this.getDevices();
			},
			pageDvSized(val) {
				this.$gRow = val;
				this.getDevices();
			},
			getDevices() {
				var vl = this.srchValue ? this.srchValue : "";
				var channel = this.channelId ? this.channelId : "";
				var status = this.status ? this.status : "";
				var appId = this.appId ? this.appId : "";
				this.dvLoading = 1;
				if (this.$appUrlTag === 0) {
					this.$getDevices(
						this.dvIndex,
						this.$gRow,
						channel,
						vl,
						status,
						"",
						appId,
						res => {
							// console.log('dv', res)
							this.dvLoading = 0;
							if (res.data) {
								this.dvTableData = res.data;
								this.dvTotal = res.total;
							}
						},
						() => {
							// error
							this.dvLoading = 0;
						}
					);
				} else {
					this.$getDevices1(
						this.dvIndex,
						this.$gRow,
						this.mechanismId,
						vl,
						status,
						"",
						appId,
						res => {
							console.log("dv", res);
							this.dvLoading = 0;
							if (res.data) {
								this.dvTableData = res.data;
								this.dvTotal = res.total;
							}
						},
						() => {
							// error
							this.dvLoading = 0;
						}
					);
				}
			},
			pushApp(row) {
				//console.log(row)
				//return
				/*this.appId = row.appdevid
				  this.getDevices()
				  this.dialogVisible = 1*/

				this.$setWObj("pushList", {
					data: row,
					type: "1"
				});
				this.$router.push({
					path: "/appList/pushapp"
				});
				//this.$router.push({name: this.$t('menu.appManageSub.customPush')})
			},
			query() {
				this.getAppList();
			},
			selectChange(vl) {
				this.getAppList();
			},
			reset() {
				this.queryKey = "";
				this.appType = "";
				this.getAppList();
			},
			pageSelect(index) {
				this.$setWPage("appPage", index);
				this.getAppList();
			},
			pageDvSelect(index) {
				this.dvIndex = index;
				this.getDevices();
			},
			pageSized(val) {
				this.$gRow = val;
				this.getAppList();
			},
			deleteApp(obj) {
				this.$showConfirm(
					this.$t("app_tip"),
					this.$t("app_tipMkDel"),
					this.$t("app_sure"),
					this.$t("app_cancel"),
					"warning",
					() => {
						// console.log(obj)
						if (this.$appUrlTag === 0) {
							this.$deleteApp(
								obj.applicationid,
								res => {
									if (res.status === 200) {
										this.getAppList();
									} else {
										this.$message(res.message);
									}
								},
								""
							);
						} else {
							this.$deleteApp1(
								obj.applicationid,
								res => {
									if (res.status === 200) {
										this.getAppList();
									} else {
										this.$message(res.message);
									}
								},
								""
							);
						}
					},
					""
				);
			},
			submitApp(obj) {
				this.$showConfirm(
					this.$t("app_tip"),
					this.$t("app_tipVerify"),
					this.$t("app_sure"),
					this.$t("app_cancel"),
					"warning",
					() => {
						this.loading = 1;
						if (this.$appUrlTag === 0) {
							this.$submitVerifyApp(
								obj.applicationid,
								res => {
									this.loading = 0;
									if (res.status === 200) {
										this.getAppList();
									} else {
										this.$message.error(res.message);
									}
								},
								() => {
									this.loading = 0;
								}
							);
						} else {
							this.$submitVerifyApp1(
								obj.applicationid,
								res => {
									this.loading = 0;
									if (res.status === 200) {
										this.getAppList();
									} else {
										this.$message.error(res.message);
									}
								},
								() => {
									this.loading = 0;
								}
							);
						}
					},
					""
				);
			},
			cellClick(row, ev, col) {
				var label = col.label
				if (!label) return
				if (label === this.$t("app_operate")) {
					return;
				}
				// else if (label === this.$t('app_distributor')) {
				// this.$setWObj("appChannelDetail", row);
				// this.$router.push({ path: "/appList/merchants-details" });
				// }
				else {
					// to detail
					// var cf = {};
					// var path = "";
					// if (row.appStatus === "1" || row.appStatus === "2") {
					//   cf.type = 2;

					//   path = "/applist/display";
					// } else {
					//   cf.type = 1;
					//   path = "/applist/edit";
					// }
					// cf.data = row;
					// this.$setWObj("editAppConfig", cf);
					// this.$router.push({ path: path });

					/////////edit
					// this.$setWObj("editAppConfig", {data:row,type:1});
					// this.$router.push({ path: '/applist/edit' });
					////////// detail use new

					this.$setWObj("appDisplay", {
						appid: row.applicationid,
						mech: row.distributorId
					});
					this.$router.push({
						path: '/applist/display'
					});
				}

			},
			jumpToUpload() {

				//证书类型为：客户定制，则不做是否有证书的判断
				if (localStorage.cerType === '2') {
					this.$setWObj("editAppConfig", {
						type: 0
					});
					this.$router.push({
						path: '/appList/upload'
					});
					return
				}

				this.loading = 1;
				this.$isCer(
					this.mechanismId,
					res => {
						this.loading = 0;
						// console.log('cer', res)
						if (!res.data) {
							this.$setWObj("editAppConfig", {
								type: 0
							});
							this.$router.push({
								path: 'appList/upload'
							});
						} else {
							//this.$message.error(res.message)
							//this.$router.push({path: "/certificate/new"})
							this.cerTipMsg = res.message;
							var vl = localStorage.cerType;
							if (vl === "0") {
								// self
								this.cerDialogVisible = true;
							} else {
								// other
								this.cerTipDialogVisible = true;
							}
						}
					},
					() => {
						// this.$message(this.$t('app_rqsError'))
					}
				);
			},
			getAppList(isRfType) {
				this.loading = 1;
				var type = this.appType.length > 0 ? this.appType[0] : "";
				var name = this.queryKey ? this.queryKey : "";
				var mcId = this.mechId ? this.mechId : '' /////this.mechanismId

				if (isRfType) {
					var _this = this
					this.$gpAppType(mcId, (res) => {
						if (res.data.length > 0) {
							_this.appTypes = res.data[0].children
						}
					})
				}

				var appvst = this.appvst
				this.$getAppList1(
					this.$gRow,
					this.$getWPage("appPage"),
					mcId,
					type,
					name,
					appvst,
					this.orderName,
					this.orderType,
					this.pkg ? this.pkg : '',
					res => {
						console.log(res);
						this.loading = 0;
						if (res.status === 200) {
							this.total = res.total;
							this.tableData = res.data;
						} else {
							this.$message(res.message);
						}
					},
					() => {
						this.loading = 0;
						this.$message.error(this.$t("app_rqsError"));
					}
				);

			},
			dateFormat(row, column) {
				var date = row[column.property];
				if (date === undefined) {
					return "";
				}
				return mm(date).format("YYYY-MM-DD HH:mm:ss");
			},
			setInstallType(type) {
				return this.$installType[type];
			}
		},
		mounted() {
			var _this = this
			this.mechanismData = {
				callback(value) {
					_this.mechId = value
					_this.getAppList(true)
				}
			}

			//this.getChannels()
			this.getAppList(true)

		},
		destroyed() {}
	};
</script>


// WEBPACK FOOTER //
// list.vue?2ccdd8f4